import React from 'react';

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
  error?: unknown;
};

export class RouteErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: unknown): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: unknown) {
    console.error('[RouteErrorBoundary] route render error', error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen flex items-center justify-center px-6 py-16 bg-white dark:bg-surface-base">
        <div className="w-full max-w-md rounded-2xl border border-gray-200 dark:border-surface-border bg-white dark:bg-surface-paper p-6 text-center shadow-sm">
          <h2 className="text-lg font-bold text-gray-900 dark:text-white">Terjadi kendala saat memuat halaman</h2>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">
            Coba muat ulang. Biasanya ini terjadi setelah update aplikasi di server (cache aset belum sinkron).
          </p>
          <button
            className="mt-5 w-full rounded-xl bg-blue-600 px-4 py-3 text-sm font-semibold text-white hover:bg-blue-700 transition"
            onClick={() => window.location.reload()}
          >
            Muat ulang
          </button>
        </div>
      </div>
    );
  }
}

